import AssetLibrary from "../assets/asset-library";
import MaterialBuilder from "../rendering/material-builder";
import ensureArray from '../utils/ensure-array';

const LAYER_NONE = 0;
const LAYER_STENCIL = 1;

const SCALE = 100;

class Gate extends THREE.Mesh {
    constructor() {
        const geometry = new THREE.SphereBufferGeometry(1, 16, 16);
        const material = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide });

        super(geometry, material);

        this.layers.set(LAYER_STENCIL);

        this.isUniformScale = true;
        this.isGate = true;
        this.type = "Gate";

        this._scene = new THREE.Scene();

        // (() => {
        //     const mesh = new THREE.Mesh(new THREE.TorusKnotGeometry(), new THREE.MeshBasicMaterial({ color: 0xff00ff }));
        //     mesh.scale.set(10, 10, 10);
        //     this._scene.add(mesh);
        // })();

        this._sphere = new THREE.Sphere(undefined, SCALE);
        this._helper = null;

        // this._helper = new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({ color: 0xff0000, wireframe: true }));
        // this._scene.add = (...elements) => {
        //     THREE.Scene.prototype.add.call(this._scene, ...elements);

        //     elements.forEach(el => {
        //         el.traverse(el => {
        //             if (el.geometry) {
        //                 if (!el.geometry.boundingSphere) el.geometry.computeBoundingSphere();

        //                 const radius = el.geometry.boundingSphere.radius;
        //                 const distance = el.geometry.boundingSphere.center.length();

        //                 const outDistdistance = Math.max(SCALE, radius + distance) * 2.5;

        //                 this._sphere.radius = outDistdistance * outDistdistance;

        //                 // if (this._helper) this._helper.scale.set(1, 1, 1).multiplyScalar(this._sphere.radius);
        //             }
        //         });
        //     });
        // }

        // this.add(this._display);
    }

    update(sceneBoundingBox) {
        if (this._helper) this._scene.remove(this._helper);

        const bbox = new THREE.Box3();
        this._scene.scale.set(1, 1, 1);
        this._scene.position.set(0, 0, 0);

        if (sceneBoundingBox) bbox.copy(sceneBoundingBox);
        else bbox.setFromObject(this._scene);

        if (this._helper) this._scene.add(this._helper);

        const sphere = bbox.getBoundingSphere(this._sphere);

        const dist = sphere.center.length();
        const radius = sphere.radius;

        const scale = new THREE.Vector3(1 / this._scene.scale.x, 1 / this._scene.scale.y, 1 / this._scene.scale.z);
        // const size = bbox.getSize();

        // const distance = scale.multiply(size).length();

        // const outDistdistance = Math.max(SCALE, distance);

        // this._sphere.radius = outDistdistance;

        const outDistdistance = Math.max(SCALE, (dist + radius) * scale.length()) * 2.5;
        this._sphere.radius = outDistdistance;

        if (this._helper) this._helper.scale.set(outDistdistance, outDistdistance, outDistdistance).multiplyScalar(0.8);
    }

    get boundingRadius() { return this._sphere.radius; }
    get scene() { return this._scene; }
    get root() { return this._scene; }

    addHelpers(color = 0xff0000) {
        const geo = new THREE.SphereBufferGeometry(1, 32, 32);

        let mat = MaterialBuilder.build({ color: 0x113356, transparent: true, opacity: 0.7, side: THREE.BackSide });
        mat.envMap = AssetLibrary.envLight.activeMap;

        let outer = new THREE.Mesh(geo, mat);
        outer.dontShowInHierarchyPanel = true;
        outer.isUnselectable = true;
        outer.scale.set(0.8, 0.8, 0.8);
        this.add(outer);

        mat = MaterialBuilder.build({ color: 0x000000, transparent: true, opacity: 0.7, side: THREE.BackSide });
        mat.envMap = AssetLibrary.envLight.activeMap;
        outer = new THREE.Mesh(geo, mat);
        outer.dontShowInHierarchyPanel = true;
        outer.isUnselectable = true;
        outer.scale.set(0.77, 0.77, 0.77);
        this.add(outer);

        // this.add(new THREE.Mesh(geo, new THREE.MeshBasicMaterial({color:0xff0000, wireframe:true})));
    }

    /**
     * 
     * @param {THREE.WebGLRenderer} renderer 
     * @param {THREE.PerspectiveCamera} camera
     * @param {number} layer
     */
    render(renderer, camera, layer, target) {
        if (!this.visible) return;

        const gl = renderer.getContext();

        camera.layers.set(LAYER_NONE);
        gl.stencilFunc(gl.EQUAL, layer, 0xff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);

        gl.colorMask(true, true, true, true);
        gl.depthMask(true);

        const invScale = 1 / this.boundingRadius;
        this._scene.scale.set(invScale, invScale, invScale);
        this.getWorldPosition(this._scene.position);

        this._scene.traverse(object => {
            if (object.material) {
                let materials = ensureArray(object.material);
                for (let material of materials) {
                    if (material.isMeshNestedMaterial) {
                        material.updateLayers(object);
                    }
                }
            }
        });

        renderer.render(this._scene, camera, target);
    }
}

export default Gate;
export { Gate, LAYER_NONE, LAYER_STENCIL };